import * as React from 'react'
import { IVehicleObj } from '../../../types'

const Accommodations = (props: { vehicle: IVehicleObj }) => {
  const { accommodations } = props.vehicle
  return (
    <div className='ml3'>
      <div className='mt2 bold'>Accommodations</div>
      <div className='col-3 mt2'>
        {!accommodations.length && <div>No accommodations</div>}
        {accommodations.length && (
          <div>
            <div className='flex justify-between bb-light-grey4 py1'>
              <div className='h6 font-light-blue-grey bold'>Name</div>
              <div className='h6 font-light-blue-grey bold'>Quantity</div>
            </div>
            {accommodations.map(it => (
              <div className='flex justify-between bb-light-grey4 py1' key={it.accommodationId}>
                <div className='h5 font-dark-grey'>{it.name}</div>
                <div className='h5 font-dark-grey'>{it.number}</div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}

export default Accommodations



// WEBPACK FOOTER //
// ./src/components/vehicles/viewVehicle/Accommodations.tsx